import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["form"];

  connect() {
    fetch("/accounts/csrf_meta.json", { credentials: "same-origin" })
      .then(response => response.json())
      .then(json => {
        $("<meta>")
          .attr("name", "csrf-param")
          .attr("content", json.param)
          .appendTo("head");

        $("<meta>")
          .attr("name", "csrf-token")
          .attr("content", json.token)
          .appendTo("head");

        // add latest CSFR token to user sign in modal
        this._assignCSRFTokenToModalForm(json.token);
      })
  }

  _assignCSRFTokenToModalForm(token) {
    this.formTargets.forEach(target => {
      var tokenHiddenField = document.createElement("input");
      tokenHiddenField.setAttribute("type", "hidden");
      tokenHiddenField.setAttribute("name", "authenticity_token");
      tokenHiddenField.setAttribute("value", token);
      target.appendChild(tokenHiddenField);
    });
  }
}
